<template>
  <div class="variety-wrap">
    <h-select-tree v-model="bindForm[prop]" :first-value.sync="viewValue" :data="treeData" :check-strictly="checkStrictly"
      :only-child="onlyChild" :filterable="filterable" :transfer="transfer" :size="size" :showCheckbox="showCheckbox"
      :showBottom="showBottom" :disabled="disabled" :setValueNotEmit="setValueNotEmit" :placement="placement" :placeholder="placeholder" :searchHolder="searchHolder"
      @on-select-change="onSelectChange" @on-check-change="onCheckChange" ref="varietyTree" :showTitle="true">
    </h-select-tree>
  </div>
</template>
<script>
export default {
  name: 'HVarietyTree',
  props: {
    query: Object,
    bindForm: Object,
    prop: {
      type: String,
      required: true
    },
    requestUrl: {
      type: String,
      required: true
    },
    responseType: {
      type: Object,
      default () { // 自定义返回字段
        return {
          type: 'data',
          rows: 'varietyList',
        }
      }
    },
    dataTransfer: {// 数据转换
      type: Function,
      default () {
        return null
      }
    },
    filterable: {
      type: Boolean,
      default: true
    },
    checkStrictly: {
      type: Boolean,
      default: true
    },
    onlyChild: {
      type: Boolean,
      default: true
    },
    transfer: {
      type: Boolean,
      default: false
    },
    showBottom: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    setValueNotEmit: {
      type: Boolean,
      default: false
    },
    size: String,
    placement: String,
    searchHolder: String,
    placeholder: {
      type: String,
      default: '请选择品种'
    }
  },
  data () {
    return {
      treeData: []
    }
  },
  created () {
    this.loadTreeData()
  },
  computed: {
    viewValue () {
      return this.bindForm[this.prop]
    }
  },
  methods: {
    loadTreeData () {
      const me = this
      // 设置查询参数
      let param = {}
      Object.assign(param, me.query)
      let _value = me.viewValue
      me.bindForm[me.prop] = ''
      me.$request.jsonRequest(me.requestUrl, param).then(r => {
        if (r) {
          // 数据特殊处理
          let transfer = me.dataTransfer(r)
          r = transfer || r
          const { rows, type } = me.responseType
          let ds = r[type]
          me.treeData = me.getTreeNode(ds[rows], '#')
          me.bindForm[me.prop] = _value
        }
      }).catch(e => {
        console && console.error(e)
      })
    },
    // 转换后台获取到的品种数据
    getTreeNode (data, parent) {
      const me = this
      let treeNodes = []
      if (!data || !data.length) {
        return treeNodes
      }
      data.filter(it => it.enableFlag === '1').forEach(node => {
        if (node.parentVarietyCode === '') {
          node.parentVarietyCode = null
        }
        if (node.parentVarietyCode === parent) {
          let childNode = { expand: true }
          Object.assign(childNode, node)
          childNode.title = node.varietyName
          if (node.childFlag === '0') {
            var child = me.getTreeNode(data, node.varietyCode)
            if (child.length) {
              childNode.children = child
            }
          }
          treeNodes.push(childNode)
        }
      })
      return treeNodes
    },
    onSelectChange (nodes) {
      if (!nodes || !nodes.length) {
        return this.$toast('warn', '请选择品种')
      }
      this.$emit('onSelectChange', nodes)
    },
    onCheckChange (nodes) {
      this.$emit('onCheckChange', nodes)
    },
    clearSelectedVal () {
      let ref = this.$refs['varietyTree']
      ref.viewValue = ''
      ref.titleTip = ''
      if (this.showCheckbox) {
        let mult = ref.selectedMultiple
        mult.splice(0, mult.length)
      } else {
        ref.selectedSingle = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
